import React, { useEffect, useState } from 'react'
import { Select } from 'components/form'

import { getProfiles } from './actions'

interface ComponentProps {
  name: string
  label: string
  desktopSize?: number
  tabletSize?: number
  disabled?: boolean
  [x: string]: any
}

const Component: React.FC<ComponentProps> = ({ name, label, desktopSize, tabletSize, ...rest }) => {
  const [profiles, setProfiles] = useState<Array<any>>([])

  useEffect(() => {
    const load = async () => setProfiles([...[{ value: null, label: '' }], ...(await getProfiles())])

    load()

    return () => {}
  }, [])

  return <Select name={name} label={label} options={profiles} desktopSize={desktopSize} tabletSize={tabletSize} {...rest} />
}

export default Component
